/* eslint-disable @typescript-eslint/no-misused-promises */
import React, { useEffect, useMemo, useState } from 'react';
import classNames from 'classnames';
import './index.scss';
import ErrorInfo from '../../pages/report/component/errorInfo';
import Loading from '@/pages/dashboard/components/Loadings';
import { getLocale } from 'umi';
import { generateTokens } from '@home/services/report';
import { LookerReportType, ReportInfoType } from './type';

const INIT_REPORT_INFO: ReportInfoType = {
  noReport: false,
  reportUrl: '',
  errMsg: ''
};

const LookerCookieless = (props: LookerReportType) => {
  const { loading, sessionInfo, className, style, onSuccess, onFail } = props || {};
  const [reportInfo, setReportInfo] = useState<ReportInfoType>(INIT_REPORT_INFO);
  const locale = getLocale();
  const isEn = locale === 'en-US';
  let connected = false;  // 用于判断是否已经连接

  const { authentication_token, navigation_token, embed_url, host } = sessionInfo;

  useEffect(() => {
    const openIframeReport = () => {
      setReportInfo({
        ...INIT_REPORT_INFO,
      });

    

      const cookielessReportUrl = getCookielessLoginUrl(embed_url, authentication_token, navigation_token);

      setReportInfo({
        reportUrl: cookielessReportUrl,
        errMsg: '',
        noReport: !cookielessReportUrl,
      });

      onSuccess?.();
    };

    openIframeReport();

    // 监听iframe消息
    const handleIframeMessage = async (event: MessageEvent) => {
      // 过滤非目标来源的消息
      if (!host || event.origin !== host) {
        return;
      }

      // 兼容字符串和对象两种格式
      let message;
      try {
        message = typeof event.data === 'string' ? JSON.parse(event.data) : event.data;
      } catch (error) {
        // 忽略无法解析的消息（可能来自浏览器插件或其他脚本）
        console.warn('[LookerCookieless] Failed to parse message:', event.data);
        return;
      }

      // 只处理目标类型的消息
      if (message?.type === 'session:tokens:request') {
        await sessionTokensRequestHandler();
      }
    };
      
    window.addEventListener('message', handleIframeMessage);
      
    // 组件卸载时清理事件监听器
    return () => {
      window.removeEventListener('message', handleIframeMessage);
    };

  }, [sessionInfo]);

  const getCookielessLoginUrl = (reportUrl: string, authentication_token: string, navigation_token: string) => {
    const embedUrl = new URL(reportUrl, host);
    if (!embedUrl.searchParams.has('embed_domain')) {
      embedUrl.searchParams.set('embed_domain', window.location.origin);
    }
    embedUrl.searchParams.set('embed_navigation_token', navigation_token);

    const targetUri = encodeURIComponent(
      `${embedUrl.pathname}${embedUrl.search}${embedUrl.hash}`
    );
    return `${embedUrl.origin}/login/embed/${targetUri}?embed_authentication_token=${authentication_token}`;
  };

  
  // 处理会话令牌请求的函数
  const sessionTokensRequestHandler = async () => {
    const contentWindow = document.querySelector('iframe')?.contentWindow;
    if (contentWindow) {
      if (!connected) {
        // 如果未连接，则使用新获取的令牌
        const sessionTokens = sessionInfo;
        if (sessionTokens) {
          connected = true;
          send('session:tokens', sessionTokens, contentWindow);
        }
      } else {
        // 如果已连接，则生成新的令牌
        const sessionTokens = await generateTokens({url: `${host}${embed_url}`});
        send('session:tokens', sessionTokens, contentWindow);
      }
    }
  };

  
  // 发送消息的函数
  const send = (messageType: string, data: any = {}, contentWindow: Window) => {
    const message = {
      type: messageType,
      ...data,
    };
    contentWindow.postMessage(JSON.stringify(message), host);
  };

  const errorInfo = useMemo(() => {
    if (reportInfo.noReport) {
      onFail?.();
      return <ErrorInfo isEn={isEn} />;
    }
    return null;
  }, [reportInfo.noReport, isEn]);

  return (
    <>
      {loading ? (
        <Loading />
      ) : (
        <>
          {errorInfo || (
            <div className={classNames('dtb-db-iframe-wrap db-report-looker', className)} style={style}>
              <iframe
                title="looker"
                className='dtb-db-iframe'
                src={reportInfo.reportUrl}
              />
            </div>
          )}
        </>
      )}
    </>
  );
};

export default LookerCookieless;
